import { render, staticRenderFns } from "./CalendarAnnouncement.vue?vue&type=template&id=782a2475&"
import script from "./CalendarAnnouncement.vue?vue&type=script&lang=ts&"
export * from "./CalendarAnnouncement.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarAnnouncement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports